export default "__VITE_ASSET__CbZ9HLqv__"